/** @jsxImportSource @emotion/react */
import { theme } from '@app/styles/theme'
import { css } from '@emotion/react'

export const tabsWrapper = css`
  margin-top: 16px;
`

export const layoutWrapper = css`
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
`

export const container = css`
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  max-width: 1920px;
  width: 100%;
  margin: 0 auto;
`

export const outletWrapper = css`
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  margin-top: 4px;
`

export const hazardTableContainer = css`
  width: 100%;
  max-width: 1440px;
  margin: 0 auto;

  @media (min-width: 1536px) {
    max-width: 1680px;
    padding: 0 ${theme.spacing(10)};
  }

  @media (min-width: 1920px) {
    max-width: 1840px;
    padding: 0 ${theme.spacing(12)};
  }

  @media (min-width: 2200px) {
    max-width: 2000px;
    padding: 0 ${theme.spacing(16)};
  }
`
